"use strict";

exports.__esModule = true;
exports.default = void 0;

var _uiSchema = _interopRequireDefault(require("./header/uiSchema"));

var _uiSchema2 = _interopRequireDefault(require("./body/uiSchema"));

var _uiSchema3 = _interopRequireDefault(require("./isPartOf/uiSchema"));

var _uiSchema4 = _interopRequireDefault(require("./settings/uiSchema"));

var _uiPreview = _interopRequireDefault(require("./uiPreview"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "ui:field": "pageEditor",
  "ui:preview": _uiPreview.default,
  "ui:fieldset": ["content", "settings"],
  "settings": _uiSchema4.default,
  "content": {
    "ui:field": "pageContent",
    "ui:fieldset": ["header", "body", "isPartOf"],
    "header": _uiSchema.default,
    "body": _uiSchema2.default,
    "isPartOf": _uiSchema3.default
  }
};
exports.default = _default;
module.exports = exports.default;